module.exports = __webpack_public_path__ + "static/0013-a838c2544bd39a29a32c4392d6a7b412.png";